"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = void 0;
const react_1 = __importStar(require("react"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const material_1 = require("@mui/material");
const select_arrow_svg_1 = __importDefault(require("@components/icons/select-arrow.svg"));
const common_1 = require("@components/common");
const StyledSelect = (0, material_1.styled)(Select_1.default)(() => ({
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '& .MuiSelect-outlined': {
        paddingRight: '16px 0 0  20px!important',
        fontFamily: 'Inter',
        color: '#323030',
        textAlign: 'left',
        fontSize: '14px',
        lineHeight: 'normal',
        position: 'absolute',
        zIndex: 1,
        boxSizing: 'border-box',
        height: '50px!important'
    },
    '& img': {
        width: '24px',
        marginRight: '5px'
    },
    'ul li.MuiButtonBase-root': {
        fontSize: '16px!important'
    }
}));
const FilterSelect = ({ onChange, options, value }) => {
    const arrowRef = (0, react_1.useRef)();
    const openSelect = (ev) => {
        const parent = ev.target.parentElement.parentElement.querySelector('.MuiSelect-select');
        console.log(parent);
        parent.click();
        const evt = new Event('click', { bubbles: true });
        parent.dispatchEvent(evt);
    };
    return (react_1.default.createElement(StyledSelect, { value: value, onChange: onChange, style: {
            width: '100px',
            margin: 0,
            border: '1px solid #ced4da',
            height: '50px',
            marginLeft: '24px',
            color: '#212529'
        }, IconComponent: (props) => {
            console.log(props);
            return react_1.default.createElement(common_1.Box, { onClick: openSelect, style: { cursor: 'pointer', position: 'absolute', right: 0 }, className: "mui-select-arrow" },
                react_1.default.createElement(select_arrow_svg_1.default, null));
        }, onOpen: (ev) => {
            var _a, _b;
            // @ts-ignore
            arrowRef.current = ev.target.parentElement.querySelector('.mui-select-arrow');
            // @ts-ignore
            (_b = (_a = arrowRef.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('open');
        }, 
        // @ts-ignore
        onClose: () => { var _a, _b; return (_b = (_a = arrowRef.current) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove('open'); } }, options === null || options === void 0 ? void 0 : options.map(e => react_1.default.createElement(MenuItem_1.default, { className: "filter-select-item", key: e.value, value: e.value }, e.name))));
};
exports.FilterSelect = FilterSelect;
